export default "__VITE_ASSET__CFCtRAMc__"